module.exports = __webpack_public_path__ + "9c95e083d363fb0d0c493e376622574a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/otag-bouteille.svg
// module id = 768
// module chunks = 0